import moment from "moment";

/**
 * Returns time left in seconds, or if time has passed it reeturns 0
 * @param {string} dateStr 
 * @returns {func}
 */
export function getTimeLeftSeconds(dateStr) {
    if(dateStr && dateStr.length>0){
        const eventTime = moment(dateStr).unix();
        const currentTime = moment().unix();
        const diffTime = eventTime - currentTime;
        if( diffTime>0 ) {
            const duration = moment.duration(diffTime * 1000, "milliseconds");
            const h = moment.duration(duration).hours() + (moment.duration(duration).days()*24);
            const m = moment.duration(duration).minutes();
            const s = moment.duration(duration).seconds();
            return (h*3600) + (m*60) + s;
        }
    }
    return 0;
}

/**
 * Returns hour/minutes left untill a certain date, from now
 * @param {object} localization
 * @param {string} dateStr 
 * @returns {func}
 */
export function getTimeLeftStr(localization, dateStr) {
    if(dateStr && dateStr.length>0){
        const eventTime = moment(dateStr).unix();
        const currentTime = moment().unix();
        const diffTime = eventTime - currentTime;
        if( diffTime>0 ) {
            const duration = moment.duration(diffTime * 1000, "milliseconds");
            const h = moment.duration(duration).hours() + (moment.duration(duration).days()*24);
            if( h>=48 ) {
                const days = Math.floor(h/24);
                return localization.text("time","days",{days});
            }
            const m = moment.duration(duration).minutes();
            if( h>=24 ) {
                return `${h}h`;
            }
            if( h>0 || m>=2 ){
                return `${h}h ${m}m`;
            }
            const s = Math.max(0,(moment.duration(duration).minutes()*60)+moment.duration(duration).seconds()-2);//-2 is just so we can hitt 0s for some time before it locks down
            return `${s}s`;
        }
        return localization.text("time","locked");
    }
    return "-- --";
}

/**
 * Returns true if there is days left
 * @param {string} dateStr 
 * @returns {func}
 */
export function isTimeLeftInDays(dateStr) {
    if(dateStr && dateStr.length>0){
        const eventTime = moment(dateStr).unix();
        const currentTime = moment().unix();
        const diffTime = eventTime - currentTime;
        if( diffTime>0 ) {
            const duration = moment.duration(diffTime * 1000, "milliseconds");
            const h = moment.duration(duration).hours() + (moment.duration(duration).days()*24);
            return h>=24;
        }
    }
    return false;
}